/* webpack-strip-block:removed */

import { doBulkAjax } from 'Lib/ajax-util';
import axios from 'axios';

/**
 * The API endpoint pertaining to artwork.
 *
 * @type string
 */
export const ARTWORK_DATA_URI = '/api/v1/artwork';

/**
 * Fetches artworks from the API and returns them:
 * ```js
 * const aws = fetchArtworks();
 * ```
 *
 * @return { Promise.<Models.Artwork[] | undefined> }
 */
export const fetchArtworks = async ({ url_params = {}, request_data = {} }) => {
  const url = new URL(`${window.location.origin}${ARTWORK_DATA_URI}`);
  Object.entries(url_params).forEach(([param, value]) => {
    url.searchParams.append(param, value);
  });

  try {
    const response = await axios.get(url.href, request_data);
    return {
      artworks: response.data.data,
      total: response.data.paginator.total,
    };
  } catch (error) {
    toastr.error("Unable to load artworks");
    console.error(error.response.data);
  }
};

/**
 * Makes parallel PATCH requests for each artwork in `updated_artworks`.
 *
 * @param  { ...Artwork } updated_artworks Updated definitions for artwork(s), to be updated on backend.
 */
export const patchArtworks = async (...updated_artworks) => doBulkAjax(
  updated_artworks,
  async artwork => (await axios.patch(`${ARTWORK_DATA_URI}/${artwork.uuid}`, artwork)),
  'Update successful for Artwork',
);

/**
 * Makes a DELETE request for every artwork in `artworks`.
 *
 * @param  { ...Artwork } artworks
 *
 */
export const destroyArtworks = async (...artworks) => doBulkAjax(
  artworks,
  async artwork => (await axios.delete(`${ARTWORK_DATA_URI}/${artwork.uuid}`)).data,
  `Deletion successful`,
);
